import { render, staticRenderFns } from "./TBody.vue?vue&type=template&id=7caf0f2e&"
import script from "./TBody.js?vue&type=script&lang=js&"
export * from "./TBody.js?vue&type=script&lang=js&"
import style0 from "./TBody.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports